import React from "react";
import Prose from "../utility/prose";
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import CustomForm from '../utility/customForm'


const ENews = () => {


    return (
        <div className="prose prose-green dark:prose-invert max-w-none mx-auto mb-14">
            <div className="text-center">
                <MailchimpSubscribe
                    url="https://touchstonedistrictservices.us19.list-manage.com/subscribe/post?u=9e9660a8cc948aa82bf3acc40&amp;id=7ced270cb1&amp;f_id=00fdb1e7f0"
                    render={({ subscribe, status, message }) => (
                        <CustomForm
                            status={status}
                            message={message}
                            onValidated={formData => subscribe(formData)}
                        />
                    )}
                />
            </div>
        </div>
    )
}

export default ENews
